(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["server"] = factory();
	else
		root["server"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Server = __webpack_require__(1);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Server).default;
	  }
	});
	Object.defineProperty(exports, 'Server', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Server).default;
	  }
	});
	
	var _Action = __webpack_require__(3);
	
	Object.defineProperty(exports, 'Action', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Action).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lang = __webpack_require__(2);
	
	var _Action2 = __webpack_require__(3);
	
	var _Action3 = _interopRequireDefault(_Action2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * @type {Object}
	 * @see http://github.github.io/fetch/#options
	 * @see https://learn.javascript.ru/fetch
	 */
	var OPTIONS = {
	  method: 'POST',
	  headers: {
	    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
	  }
	};
	
	var Server = function () {
	  /**
	   * @param {Object} actions
	   */
	  function Server(actions) {
	    _classCallCheck(this, Server);
	
	    this.defaultOptions = (0, _lang.extend)({}, OPTIONS);
	    this.onError = this.onError.bind(this);
	    this.addActions(actions);
	  }
	  /**
	   * Adds methods to server object
	   * @param {Object} actions
	   */
	
	
	  _createClass(Server, [{
	    key: 'addActions',
	    value: function addActions(actions) {
	      for (var key in actions) {
	        var action = actions[key];
	        if ((0, _lang.isString)(action)) {
	          this.addAction(key, { url: action });
	        } else {
	          this.addAction(key, action); // action is object
	        }
	      }
	    }
	    /**
	     * Adds method to server object
	     * @param {String} key
	     * @param {Object} options
	     */
	
	  }, {
	    key: 'addAction',
	    value: function addAction(key, options) {
	      var options_ = (0, _lang.extend)({}, this.defaultOptions, options);
	      var onError = this.onError;
	
	      var Constructor = this.constructor.Action();
	      var action = new Constructor(options_, { onError: onError }); // usage DI
	      this[key] = action;
	    }
	    /**
	     * @param {Object} error
	     */
	
	  }, {
	    key: 'onError',
	    value: function onError(error) {
	      console.warn(error);
	      return error;
	    }
	    /**
	     * DI
	     * @constructor
	     */
	
	  }], [{
	    key: 'Action',
	    value: function Action() {
	      return _Action3.default;
	    }
	  }]);
	
	  return Server;
	}();
	
	exports.default = Server;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * @param {Object} dst
	 * @param {Object} src
	 * @returns {Object|Array}
	 */
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.extend = extend;
	exports.merge = merge;
	exports.copy = copy;
	exports.isPrimitive = isPrimitive;
	exports.isString = isString;
	exports.isUndefined = isUndefined;
	exports.request = request;
	exports.identity = identity;
	function extend(dst) {
	  for (var _len = arguments.length, src = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    src[_key - 1] = arguments[_key];
	  }
	
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = src[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var source = _step.value;
	
	      merge(dst, copy(source));
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator.return) {
	        _iterator.return();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	
	  return dst;
	}
	/**
	 * @param {Object} dst
	 * @param {Object} src
	 * @returns {Object}
	 */
	function merge(dst, src) {
	  for (var key in src) {
	    if (src.hasOwnProperty(key)) {
	      dst[key] = src[key];
	    }
	  }
	  return dst;
	}
	/**
	 * WARNING: works only with {Boolean|Number|String|Array|Object|null|undefined} types
	 * @see https://github.com/nervgh/yum.js/blob/master/src/yum.js#L143
	 * @param any
	 * @returns {*}
	 */
	function copy(any) {
	  // Number, String, Boolean, null, undefined
	  if (isPrimitive(any)) {
	    return any;
	  }
	  // We cannot copy FormData objects
	  if (isFormData(any)) {
	    return any;
	  }
	
	  var root = Array.isArray(any) ? [] : {};
	  for (var key in any) {
	    if (any.hasOwnProperty(key)) {
	      root[key] = copy(any[key]);
	    }
	  }
	  return root;
	}
	/**
	 * @param {*} any
	 * @return {Boolean}
	 */
	function isFormData(any) {
	  return Object.prototype.toString.call(any) === '[object FormData]';
	}
	/**
	 * @param {*} any
	 * @returns {Boolean}
	 */
	function isPrimitive(any) {
	  if (any === null) {
	    return true;
	  }
	  switch (typeof any === 'undefined' ? 'undefined' : _typeof(any)) {
	    case 'boolean':
	    case 'number':
	    case 'string':
	    case 'null':
	    case 'undefined':
	      return true;
	    default:
	      return false;
	  }
	}
	/**
	 * @param {*} any
	 * @returns {Boolean}
	 */
	function isString(any) {
	  return typeof any === 'string';
	}
	/**
	 * @param {*} any
	 * @returns {Boolean}
	 */
	function isUndefined(any) {
	  return any === undefined;
	}
	/**
	 * @param {String} url
	 * @param {Object} options
	 * @param {Function} fetchFn
	 * @returns {Promise}
	 */
	function request(url, options, fetchFn) {
	  var method = options.method,
	      headers = options.headers,
	      body = options.body;
	
	  var contentTypeKey = 'Content-Type';
	  var contentTypeValue = String(headers[contentTypeKey]);
	  var isJson = contentTypeValue.slice(0, 16) === 'application/json';
	  var body_ = isJson ? JSON.stringify(body) : body;
	  if (window.fetch === fetchFn) {
	    return fetchFn(url, {
	      method: method,
	      headers: headers,
	      body: body_
	    });
	  }
	  if (window.jQuery && window.jQuery.ajax === fetchFn) {
	    var isMultipart = contentTypeValue.slice(0, 19) === 'multipart/form-data' || isFormData(body_);
	    // We must remove contentType when the request is multipart/form-data
	    // Otherwise we will have the "Multipart: Boundary not found" error
	    if (isMultipart) {
	      delete headers[contentTypeKey];
	    }
	    return fetchFn(url, {
	      type: method,
	      headers: headers,
	      processData: !isMultipart,
	      // jQuery must not control contentType for "multipart/form-data" requests
	      // Otherwise we will have the "Multipart: Boundary not found" error
	      // https://stackoverflow.com/a/8244082
	      contentType: isMultipart ? false : contentTypeValue,
	      data: body_
	    });
	  }
	  throw new Error('You must specify the "fetch" function!');
	}
	/**
	 * @param {*} argument
	 * @returns {*}
	 */
	function identity(argument) {
	  return argument;
	}

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _lang = __webpack_require__(2);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Action = function () {
	  /**
	   * @param {Object} options
	   * @param {Object} callbacks
	   */
	  function Action(options, callbacks) {
	    _classCallCheck(this, Action);
	
	    var onError = callbacks.onError;
	
	    this.options = options;
	    this.isPending = false;
	    this.onError = onError;
	    this.onComplete = this.onComplete.bind(this);
	  }
	  /**
	   * @param {*} body
	   * @returns {Promise.<T>}
	   */
	
	
	  _createClass(Action, [{
	    key: 'get',
	    value: function get(body) {
	      return this.send(body, { method: 'GET' });
	    }
	    /**
	     * @param {*} body
	     * @returns {Promise.<T>}
	     */
	
	  }, {
	    key: 'post',
	    value: function post(body) {
	      return this.send(body, { method: 'POST' });
	    }
	    /**
	     * @param {*} body
	     * @param {Object} [options]
	     * @returns {Promise.<T>}
	     */
	
	  }, {
	    key: 'send',
	    value: function send(body, options) {
	      var onComplete = this.onComplete,
	          onError = this.onError;
	
	      var opts = (0, _lang.extend)({}, this.options);
	      opts = (0, _lang.isUndefined)(body) ? opts : (0, _lang.extend)(opts, { body: body });
	      opts = (0, _lang.isUndefined)(options) ? opts : (0, _lang.extend)(opts, options);
	      var fetchFn = this.constructor.fetch();
	      var promise = (0, _lang.request)(opts.url, opts, fetchFn);
	      this.isPending = true;
	      return promise.then(onComplete, onComplete).then(_lang.identity, onError);
	    }
	    /**
	     * @param {Object} error
	     */
	
	  }, {
	    key: 'onError',
	    value: function onError(error) {
	      console.warn(error);
	      return error;
	    }
	    /**
	     * @param {*} response
	     */
	
	  }, {
	    key: 'onComplete',
	    value: function onComplete(response) {
	      this.isPending = false;
	      return response;
	    }
	    /**
	     * DI
	     * @returns {Function}
	     */
	
	  }], [{
	    key: 'fetch',
	    value: function fetch() {
	      return window.jQuery && window.jQuery.ajax || window.fetch;
	    }
	  }]);
	
	  return Action;
	}();
	
	exports.default = Action;

/***/ })
/******/ ])
});
;


// WEBPACK FOOTER //
// server.min.js